export default __webpack_public_path__ + "static/indigo-984eefb0875e4c8dcdbab9e9cef0ec1d.png";